import { render, staticRenderFns } from "./FigurePage.vue?vue&type=template&id=566f7bdd&scoped=true&"
import script from "./FigurePage.vue?vue&type=script&lang=js&"
export * from "./FigurePage.vue?vue&type=script&lang=js&"
import style0 from "./FigurePage.vue?vue&type=style&index=0&id=566f7bdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f7bdd",
  null
  
)

export default component.exports